import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { getDepartmentLabel, getRolLabel } from '../../core/constants/user.constants';

@Component({
  selector: 'app-users-table',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule],
  templateUrl: './users-table.component.html',
  styleUrl: './users-table.component.scss'
})
export class UsersTableComponent {

  @Input() configTable: any;
  @Input() hasFilters = false;
  @Output() clearFilters = new EventEmitter<void>();

  faCircle = faCircle;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  getInitials(name?: string): string {
    return (name ?? '').trim().split(/\s+/).slice(0, 3).map(w => w[0]?.toUpperCase() ?? '').join('') || '?';
  }

  getDepartmentLabel(department: string): string {
    return getDepartmentLabel(department);
  }

  getRolLabel(rol: string): string {
    return getRolLabel(rol);
  }

  goToDetail(id: number) {
    const queryParams = { ...this.route.snapshot.queryParams };
    this.router.navigate(['/users/detail', id], { queryParams });
  }
}
